import React, { createContext } from 'react';

const QuotaContext = createContext();

export default QuotaContext;